import AjaxService, { validateResponse } from '../services/ajax-service';

import { handleServerError } from 'shared-services/error-service';

export const fetchRoles = ({ offset, limit }) => {
    return AjaxService({
        method: 'get',
        url: 'roles',
        params: {
            offset,
            limit
        }
    })
    .then(response => ({
        items: response.data
    }))
    .catch(handleServerError);
}

export const createRole = ({ name, permissions }) => {
    return AjaxService({
        method: 'post',
        url: 'roles',
        data: {
            name,
            permissions
        }
    })
    .then(response => response.data?.role)
    .catch(handleServerError);
}

export const fetchRole = roleId => {
    return AjaxService({
        method: 'get',
        url: `roles/${roleId}`
    })
    .then(response => validateResponse(response, 'id').data)
    .catch(handleServerError);
}

export const updateRole = (roleId, { name, permissions }) => {
    return AjaxService({
        method: 'put',
        url: `roles/${roleId}`,
        data: {
            name,
            permissions
        }
    })
    .then(response => response.data)
    .catch(handleServerError);
}

export const addRolePermission = (roleId, permission) => {
    return AjaxService({
        method: 'put',
        url: `roles/permission/${roleId}`,
        data: { permission }
    })
    .then(response => response.data)
    .catch(handleServerError);
}

export const removeRolePermission = (roleId, permission) => {
    return AjaxService({
        method: 'delete',
        url: `roles/permission/${roleId}/${permission}`
    })
    .then(response => response.data)
    .catch(handleServerError);
}


export const removeRole = roleId => {
    return AjaxService({
        method: 'delete',
        url: `roles/${roleId}`
    })
    .then(response => response.data)
    .catch(handleServerError);
}
